import { v4 as uuid } from "uuid";
import log from "js/core/logger";
import { ds } from "js/core/models/dataService";

class SearchTerms {
    constructor(searchType, workspaceId) {
        if (!searchType) {
            throw new Error("searchType required for SearchTerms");
        }
        if (!workspaceId) {
            throw new Error("workspaceId required for SearchTerms");
        }
        this.searchType = searchType;
        this.workspaceId = workspaceId;
        this.groupId = uuid();
        this.termsSet = new Set([]);
    }

    setSearchType(searchType) {
        this.searchType = searchType;
    }

    add(newTerm) {
        // when attempting to add a new term, remove all previous substrings of that term from set
        // if new term is a substring of an existing term, don't add the new term to the set
        let skipNewTerm = false;
        this.termsSet.forEach(existingTerm => {
            const oldTermIsSubString = existingTerm.length < newTerm.length && newTerm.indexOf(existingTerm) > -1;
            const newTermIsSubString = newTerm.length < existingTerm.length && existingTerm.indexOf(newTerm) > -1;
            if (oldTermIsSubString) {
                this.termsSet.delete(existingTerm);
            } else if (newTermIsSubString) {
                skipNewTerm = true;
            }
        });
        if (!skipNewTerm) {
            this.termsSet.add(newTerm);
        }
    }

    clear() {
        this.groupId = uuid();
        this.termsSet.clear();
        this.selectedItem = null;
    }

    selectItem(searchTerm, itemSelected) {
        if (!searchTerm) return;
        this.termsSet.delete(searchTerm);
        this.selectedItem = { searchTerm, itemSelected };
    }

    sendTerms() {
        this.termsSet.forEach(term => {
            log.audit("search", this.searchType, {
                term: term,
                selected: false,
                session: this.groupId,
                workspace_id: this.workspaceId
            });
        });
        this.selectedItem && log.audit("search", this.searchType, {
            term: this.selectedItem.searchTerm,
            selected: this.selectedItem.itemSelected,
            session: this.groupId,
            workspace_id: this.workspaceId
        });
    }
}

export default SearchTerms;

// CREATE TABLE IF NOT EXISTS search (id SERIAL NOT NULL PRIMARY KEY, action text, invoker text, time timestamp, datetime text, ipaddress text, term text, selected text, session text);
